import { CapoPlugin } from "/data/www/musikum_portal/prod/.app/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];